export const errors = {
   es: {
      400: "Se ha producido un error en la solicitud",
      401: "No tienes suficientes permisos para acceder al recurso",
      403: "No puedes acceder a los datos solicitados",
      404: "No se ha encontrado el recurso",
      408: "El servidor está tardando mucho en responder, inténtelo de nuevo más tarde",
      409: "Error de duplicidad",
      500: "Error del servidor"
   },
   en: {
      400: "Error requesting the resource",
      401: "You are not authorized to view the resource",
      403: "Forbidden resource",
      404: "Resource not found",
      408: "Looks like the server is taking to long to respond, please try again in sometime",
      409: "Duplicate error",
      500: "Internal server error"
   }
};
